module.exports = __webpack_public_path__ + "static/media/discard_damage_case-56.d63b497d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/discard_damage_case-56.png
// module id = 658
// module chunks = 0